<template>
  <div class="blank-layout">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'BlankLayout'
}
</script>
<style>
.blank-layout {
  min-height: 100vh;
}
</style>
